export type IdpClaim = 'sub';
export type IdpResponseType = 'code' | 
	'token' | 
	'id_token' | 
	'id_token token' | 
	'code id_token' | 
	'code token' | 
	'code id_token token';
export type IdpGrantType = 'authorization_code' | 
	'client_credentials' | 
	'password' | 
	'refresh_token' | 
	'implicit';
export type IdpResponseMode = 'form_post' | 'query' | 'fragment';
export type IdpSubjectType = 'public';
export type IdpTokenSigningValue = 'RS256';
export type IdpChallengeMethod = 'plain' | 'S256';
export type IdpAuthMethod = 'client_secret_post' | 'client_secret_basic';

export interface IdpAuth {
	accessToken: string;
	idToken: string;
	state: number;
	error: any;
	expiresIn: number;
	scope: string;
	sessionState: string;
}

export interface IdpConfig{
	authorization_endpoint: string;
	issuer: string;
	jwks_uri: string;
	token_endpoint: string;
	userinfo_endpoint: string;
	end_session_endpoint: string;
	check_session_iframe: string;
	revocation_endpoint: string;
	introspection_endpoint: string;
	http_logout_supported: boolean;
	scopes_supported: string[];
	claims_supported: IdpClaim[];
	response_types_supported: IdpResponseType[];
	response_modes_supported: IdpResponseMode[];
	grant_types_supported: IdpGrantType[];
	subject_types_supported: IdpSubjectType[];
	id_token_signing_alg_values_supported: IdpTokenSigningValue[];
	code_challenge_methods_supported: IdpChallengeMethod[];
	token_endpoint_auth_methods_supported: IdpAuthMethod[];
}

export interface IdpClientConfig {
	readonly clientId:string;
	readonly path:string;
	readonly postLogoutUri:string;
	readonly redirectUri:string;
	readonly responseType:IdpResponseType;
	readonly scope:string[];
}

export const IdpStorageKeys = {
	IDP_STATE : 'idp-state',
	REMEMBERED_EMAIL: 'sb-remembered-email',
	LAST_LINK_PASSWORD: 'sb-link-password'
};

export type IdpTokenType = 'PHOENIX-TOKEN' | 'Bearer';


// WEBPACK FOOTER //
// ./src/phoenix/domain/idp.ts